import type { z } from "zod";

import { Response } from "~/shared/api";

const zRes204 = Response.Schema.zNoBody(204);
const zRes4xx = Response.Schema.zUnsuccessful2([401, 404]);

const zRes = Response.Schema.zAggregated([zRes204, ...zRes4xx]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
